import { createStructuredSelector, createSelector } from "reselect";
import { workareaSelector } from "features/workarea/selectors";
import { organizationSelector } from "features/organization/selectors";

export const soloIsFetchingSelector = state =>
  state.solo.getIn(["upload", "soloIsFetching"]);

export const soloRawFiles = state =>
  state.solo.getIn(["upload", "soloRawFiles"]);
export const soloRawFilesSelector = createSelector(
  soloRawFiles,
  x => x && x.toJS().map(f => ({ ...f, id: f.name }))
);

export const soloFilesUploadingSelector = createSelector(
  soloRawFilesSelector,
  rF => rF.map(x => x.status).includes("pending")
);

export default createStructuredSelector({
  soloRawFiles: soloRawFilesSelector,
  soloFilesUploading: soloFilesUploadingSelector,
  soloIsFetching: soloIsFetchingSelector,
  workarea: workareaSelector,
  organization: organizationSelector
});
